import { render, staticRenderFns } from "./external-link.vue?vue&type=template&id=613407b6&"
import script from "./external-link.vue?vue&type=script&lang=js&"
export * from "./external-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports